/**
 * AddSystemUserCtrl controller
 * Add/Edit Users
 */

/**
 * AddSystemUserCtrl controller
 *
 * @class AddSystemUserCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:AddSystemUserCtrl
 */
/* @ngInject */
export default function AddSystemUserCtrl (
  $scope,
  Rule,
  Setting,
  User,
  alertSvc,
  authSvc,
  storageSvc,
  user
) {
  var vm = this

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Current user
   *
   * @memberof mwApp/settings.controller:AddSystemUserCtrl
   * @type {models.User}
   */
  vm.me = authSvc.getUser()

  // drop flag "superAdmin" if current user is not super admin
  user.superAdmin = user.superAdmin && vm.me.superAdmin

  vm.passVisible = false

  vm.twoFactorAuthEnabled = true

  /**
   * Rules list
   *
   * @memberof mwApp/catchups.controller:AddSystemUserCtrl
   * @name vm.rules
   * @type {models.User[]}
   */

  // get rules
  Rule.loadAll()
    .to(vm.rules = [])
    .then(() => { $scope.loading = false })

  Setting.loadAll()
    .to(vm.settings = {})
    .then(() => {
      vm.twoFactorAuthEnabled = vm.settings.TWO_FACTOR_AUTH_ENABLED
        ? vm.settings.TWO_FACTOR_AUTH_ENABLED.value !== false
        : true
    })

  /**
   * User
   *
   * @memberof mwApp/settings.controller:AddSystemUserCtrl
   * @type {models.User}
   */
  vm.user = user

  /**
   * isNew flag
   *
   * @memberof mwApp/settings.controller:AddSystemUserCtrl
   * @type {Boolean}
   */
  vm.isNew = user._isNew()

  /**
   * Change 'Super Admin' flag
   *
   * @memberof mwApp/settings.controller:AddSystemUserCtrl
   */
  vm.changeAdmin = function () {
    if (vm.user.superAdmin) {
      vm.user.rule = null
    }
  }

  vm.reset2fa = function () {
    if (!vm.twoFactorAuthEnabled) return
    vm.setDisable()
    vm.user._onOff('', '"RESET_OTP"')
      .then(() => { alertSvc.alert('2FA settings have been reset', 'success') })
      .finally(vm.unsetDisable)
  }

  vm.isSuperAdmin = authSvc.hasAccess('superAdmin')
  vm.isSystemUser = storageSvc.local.get('userType') === 'SYSTEM'

  /**
   * Create or edit user
   *
   * @memberof mwApp/settings.controller:AddSystemUserCtrl
   */
  vm.submit = function () {
    if (vm.isDisabled() || vm.patternError(vm.user.password) || vm.atLeastError(vm.user.password)) {
      return
    }
    vm.setDisable()
    user._save(user => {
      // TODO: change this later
      user.phone = user.phone || null
      delete user.name
      delete user.currentFail
    }).then(vm.location(user).reload)
      .catch((rejection) => alertSvc.alertError(rejection?.statusText || rejection))
      .finally(vm.unsetDisable)
  }

  /**
   * Delete user
   *
   * @memberof mwApp/settings.controller:AddSystemUserCtrl
   */
  vm.deleteUser = function () {
    vm.setDisable()
    user._delete()
      .then(vm.location(user).list)
      .catch((rejection) => alertSvc.alertError(rejection?.statusText || rejection))
      .finally(vm.unsetDisable)
  }

  /**
   * Validate password by pattern
   * @param test
   * @returns {boolean}
   */
  vm.patternError = function (test) {
    const regex = /^[a-zA-Z0-9@#$_&\-*!?. ]+$/
    return !regex.test(test)
  }

  /**
   * Show user's password
   *
   * @memberof mwApp/settings.controller:AddSubscriberCtrl
   */
  vm.viewPassword = function () {
    vm.passVisible = !vm.passVisible
  }

  /**
   * Validate password by contain symbols
   * @param test
   * @returns {boolean}
   */
  vm.atLeastError = function (test) {
    if (test) {
      return !/(?=.*[A-Z])(?=.*\d).*/.test(test)
    }
    return false
  }
}
